import React from "react";
import "./Checkbox.css";

const Checkbox = ({ checked, onChange, label, ...props }) => (
  <label className="checkbox-label">
    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      className="checkbox-input"
      {...props}
    />
    <span className="checkbox-custom" />
    {label && <span className="checkbox-text">{label}</span>}
  </label>
);

export default Checkbox;
